// extracted by mini-css-extract-plugin
export default {"img":"rCJmAJ4NGQ6F6eTIQFyC","file":"CR_ao0uXf9tqukEgBTia"};